<template>
  <div class="confetti-nav-project-logo">
    <div class="project-name">
      <div class="bold-text">{{ boldText }}</div>
      <div class="normal-text">{{ normalText }}</div>
    </div>

    <ConfettiHamburgerIcon />
  </div>
</template>

<script>
import ConfettiHamburgerIcon from "../ConfettiHamburgerIcon";

export default {
  name: "ConfettiNavProjectLogo",
  components: { ConfettiHamburgerIcon },
  props: {
    boldText: {
      type: String,
      default: null,
    },
    normalText: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/layout";
@import "confetti/scss/utils/mixins";
@import "confetti/scss/layout/hamburger-animation-mixins";
@import "confetti/scss/layout/navigation-content/confetti-nav-project-logo";
</style>
